module.exports = __webpack_public_path__ + "img/68.f2f9dd53.jpg";